import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import type { LinkedSubscriptions } from '../LinkedSubscriptions/LinkedSubscriptions';
import type { SubscriptionForm } from '../SubscriptionForm/SubscriptionForm';
import type { DropdownButton } from '../DropdownButton/DropdownButton';
import { render, html } from 'lit-html';
import { cart } from '@/theme/Cart';

import './StickyFooterBar.scss';

@Component
export class StickyFooterBar extends ThemeComponent {

    @Prop({ default: null }) scrolltarget!: string;
    @Ref({ required: false }) dropdownButton!: DropdownButton;
    @Ref({ required: false }) buttonPrice!: HTMLElement;

    private scrollTargetElement!: Element | null;
    private linkedSubscriptions: LinkedSubscriptions|null = null;
    private subscriptionForm: SubscriptionForm|null = null;
    private selectedDropdownButton: HTMLButtonElement|null = null;
    private newMarkup: HTMLElement|null = null;

    async init() {

        // Set LinkedSubscriptions component
        this.linkedSubscriptions = document.querySelector('linked-subscriptions');
        this.subscriptionForm = document.querySelector('subscription-form');

        if (this.linkedSubscriptions) {
            await this.linkedSubscriptions.init();
        }

        if (!this.linkedSubscriptions) {
            return;
        }

        // Set selected dropdown button
        this.selectedDropdownButton = this.querySelector('.button--selection-active');

        // The scroll target element is the element we check has been scrolled past
        this.scrollTargetElement = document.querySelector(this.scrolltarget);

        this.addEventListener('DropdownActive', () => {
            document.body.classList.add('overlay--active');
        });

        this.addEventListener('DropdownInactive', () => {
            document.body.classList.remove('overlay--active');
        });

        const isAbsoluter = this.linkedSubscriptions?.getAttribute('is-absoluter') == 'true';
        const isLoggedIn = this.subscriptionForm?.getAttribute('is-logged-in') == 'true';
        // Subscribe to dropdown change
        if (this.dropdownButton) {
            this.$subscribe(this.dropdownButton.onDropDownSelect, async(id) => {
                this.selectedDropdownButton = this.dropdownButton.querySelector(`#${id}`);
                const selectedDropDownButtonPrice = this.selectedDropdownButton?.getAttribute('data-price');
                const selectedDropDownButtonAbsoluterPrice =
                    this.selectedDropdownButton?.getAttribute('data-absoluter-price');

                const button = document.querySelector('.product-form__selected-price');
                const s = button?.querySelector('s') as HTMLElement;

                const hasQualifyingItem = cart.items.some((cartItem) =>
                    cartItem.properties?.['_item_absoluter_status']);

                const stickyFooter = document.querySelector('.product-sticky-footer');
                const hasAbsoluterPricing = stickyFooter?.getAttribute('data-absoluter-pricing');

                if (!hasAbsoluterPricing) {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                }else if (!isLoggedIn && !hasQualifyingItem) {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                }else if (!isLoggedIn && hasQualifyingItem) {

                    if (selectedDropDownButtonPrice && !selectedDropDownButtonAbsoluterPrice) {
                        render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                        if (s) {
                            s.style.display = 'none';
                        }
                    }else if (selectedDropDownButtonPrice && selectedDropDownButtonAbsoluterPrice){
                        render(html`- <s>${selectedDropDownButtonPrice}</s> ${selectedDropDownButtonAbsoluterPrice}`,
                            this.buttonPrice);
                        if (s) {
                            s.style.display = 'inline-block';
                        }
                    }

                }else if (
                    isLoggedIn &&
                    isAbsoluter &&
                    selectedDropDownButtonPrice &&
                    selectedDropDownButtonAbsoluterPrice
                ) {
                    render(html`- <s>${selectedDropDownButtonPrice}</s> ${selectedDropDownButtonAbsoluterPrice}`,
                        this.buttonPrice);
                    if (s) {
                        s.style.display = 'inline-block';
                    }
                }else if (
                    isLoggedIn &&
                    isAbsoluter &&
                    selectedDropDownButtonPrice &&
                    !selectedDropDownButtonAbsoluterPrice
                ) {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                    if (s) {
                        s.style.display = 'none';
                    }
                }else {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                }

                if (this.linkedSubscriptions) {
                    await this.linkedSubscriptions.updateSelectedOption(id.replace('option-', ''));
                }
            });
        }

        // Subscribe to LinkedSubscription change
        if (this.linkedSubscriptions) {
            this.$subscribe(this.linkedSubscriptions.onRadioChange, (id: string) => {
                const button = document.querySelector('.product-form__selected-price');
                const s = button?.querySelector('s') as HTMLElement;

                const hasQualifyingItem = cart.items.some((cartItem) =>
                    cartItem.properties?.['_item_absoluter_status']);

                if (this.selectedDropdownButton?.id == `option-${id}`) {
                    return;
                }
                this.updateSelectedOption(`option-${id}`);
                const selectedDropDownButtonPrice = this.selectedDropdownButton?.getAttribute('data-price');
                const selectedDropDownButtonAbsoluterPrice =
                    this.selectedDropdownButton?.getAttribute('data-absoluter-price');

                const stickyFooter = document.querySelector('.product-sticky-footer');
                const hasAbsoluterPricing = stickyFooter?.getAttribute('data-absoluter-pricing');

                if (!hasAbsoluterPricing) {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                }else if (!isLoggedIn && !hasQualifyingItem) {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                }else if (!isLoggedIn && hasQualifyingItem) {
                    if (selectedDropDownButtonPrice && !selectedDropDownButtonAbsoluterPrice) {
                        render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                        if (s) {
                            s.style.display = 'none';
                        }
                    }else if (selectedDropDownButtonPrice && selectedDropDownButtonAbsoluterPrice){
                        render(html`- <s>${selectedDropDownButtonPrice}</s> ${selectedDropDownButtonAbsoluterPrice}`,
                            this.buttonPrice);
                        if (s) {
                            s.style.display = 'inline-block';
                        }
                    }
                }else if (
                    isLoggedIn &&
                    isAbsoluter &&
                    selectedDropDownButtonPrice &&
                    selectedDropDownButtonAbsoluterPrice
                ) {
                    render(html`- <s>${selectedDropDownButtonPrice}</s> ${selectedDropDownButtonAbsoluterPrice}`,
                        this.buttonPrice);
                    if (s) {
                        s.style.display = 'inline-block';
                    }
                }else if (
                    isLoggedIn &&
                    isAbsoluter &&
                    selectedDropDownButtonPrice &&
                    !selectedDropDownButtonAbsoluterPrice
                ) {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                    if (s) {
                        s.style.display = 'none';
                    }
                }else {
                    render(html`- ${selectedDropDownButtonPrice}`, this.buttonPrice);
                }
            });
        }

        if (this.scrollTargetElement) {
            this.observeScroll();
        }

        this.handleEditScroll();

        this.$subscribe(cart.onChangeByInteraction, () => this.updateMessaging());

    }

    public updateSelectedOption(id: string) {
        if (this.dropdownButton) {
            this.dropdownButton.updateOption(id);
        }
    }

    observeScroll() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        if ('IntersectionObserver' in window) {
            const stickyBarObserver = new IntersectionObserver((entries, observer) => {
                if (!entries[0].isIntersecting) {
                    document.body.classList.add('sticky-footer-bar--active');
                } else {
                    document.body.classList.remove('sticky-footer-bar--active');
                    this.handleDropdownOpenState();
                }
            }, options);

            if (this.scrollTargetElement) {
                stickyBarObserver.observe(this.scrollTargetElement);
            }
        }
    }

    handleDropdownOpenState() {
        if (this.querySelector('.dropdown-button--active')) {
            const activeDropdown = this.querySelector('.dropdown-button--active');
            activeDropdown?.classList.remove('dropdown-button--active');
            document.body?.classList.remove('overlay--active');
        }
    }

    handleEditScroll() {
        const editButton = this.querySelector('.product-sticky-footer__edit-choices') as HTMLElement;
        const variantWrapper = document.querySelector('.variant__flavour-title') as HTMLElement;
        const headerOffset = document.querySelector('.site-header')?.clientHeight || 0;
        if (editButton && variantWrapper && headerOffset) {
            this.$listen(editButton, 'click', () => {
                const elementPosition = variantWrapper.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset;

                window.scrollTo({
                    behavior: 'smooth',
                    top: offsetPosition
                });
            });
        }
    }

    async updateMessaging() {

        // Get the selected radio
        const selectedOption = document.querySelector('.product-form__subscription-choice:checked');
        const selectedOptionFrequencyUnit = selectedOption?.getAttribute('data-frequency-unit') || 'days';
        const selectedOptionFrequency = selectedOption?.getAttribute('data-frequency');

        const url = new URL(window.location.href)
        url.searchParams.set('sections', 'product_sticky-footer-bar');
        if(selectedOptionFrequency) {
            url.searchParams.set(selectedOptionFrequencyUnit, selectedOptionFrequency);
        }
        const res = await fetch(url).then(response => response.json());

        // Create a new dom element
        const sectionMarkup = document.createElement('div');
        sectionMarkup.innerHTML = res['product_sticky-footer-bar'];
        this.newMarkup = sectionMarkup;

        // Update existing component elements
        this.updateElement('sticky-footer-bar');

    }

    updateElement(selector: string) {
        if (this.newMarkup) {
            // Replace existing page element with updated element markup
            const newStickyFooterElement = this.newMarkup.querySelector(selector);
            if (newStickyFooterElement) {
                this.outerHTML = newStickyFooterElement.outerHTML;
            }
        }
    }

}
